<template>
  <div class="items-center flex">
    <div class="flex items-center px-16 rounded-16px justify-center">
      <div class="">
        <div class="lg:flex md:flex items-center md:w-full">
          <img
            src="@/assets/images/BA 4.png"
            alt="image"
            class="w-24 mx-auto lg:mb-0 md:mb-0 mb-6"
          />
          <h1
            class="lg:font-semibold md:font-semibold font-bold lg:text-3xl md:text-3xl text-xl lg:ml-6 md:ml-6"
          >
            Select Product suites that align with your business goals.
          </h1>
        </div>

        <div class="lg:mt-0 md:mt-0 mt-8">
          <div class="lg:mt-12 md:mt-12 mt-8">
            <div class="pb-4 flex items-center relative mx-auto">
              <input
                placeholder="Search..."
                v-model="search"
                class="suites-inputbox w-full"
              />
              <div class="absolute searchicon-p">
                <feather-icon
                  icon="SearchIcon"
                  svgClass="w-2 h-2"
                  class="searchsuiteicon"
                  @click="searchCards"
                />
              </div>
            </div>
            <div
              class="lg:w-full md:w-full minscrollbar35 lg:p-4 md:p-4 p-2 m-auto"
            >
              <div
                class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-4 mad:gap-4 gap-4"
              >
                <vx-card
                  class="p-4 cursor-pointer relative shadow-md border rounded-lg"
                  v-for="(item, index) in displaySuites"
                  :key="'item_' + index"
                  :class="{
                    'bg-primary text-white': item.selectStatus
                      ? item.selectStatus
                      : false,
                  }"
                  @click="checkPlan(item)"
                >
                  <div class="flex items-center">
                    <img
                      :src="getSuiteImage(item.suiteImage)"
                      alt="image"
                      class="w-50px"
                    />
                    <div class="ml-4">
                      <p
                        class="fsize14 font-semibold"
                        :class="{
                          'text-white': item.selectStatus
                            ? item.selectStatus
                            : false,
                        }"
                      >
                        {{ item.name }}
                      </p>
                      <p class="fsize12">{{ item.extension }}</p>
                    </div>
                  </div>
                  <div
                    class="absolute top-0 right-0 customMargin"
                    v-if="
                      item.type == 'Pro' &&
                      (selectedPlan.plan.name == 'Free' ||
                        selectedPlan.plan.name == 'Starter')
                    "
                  >
                    <img
                      src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/scopeRequirements/crown2.png"
                      alt="image"
                      class="w-25px"
                    />
                  </div>
                </vx-card>
              </div>
              <!-- <infinite-loading
              v-if="loadData"
              @infinite="load"
              ref="infiniteLoading"
            >
            </infinite-loading> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="upgradePlanPopup"
      width="45%"
      class="el-header-hide rounded-lg dialogcustomclass"
      :class="[
        upgradePlans.length == 2
          ? 'planspopup600'
          : upgradePlans.length == 3
          ? 'planspopup900'
          : upgradePlans.length == 4
          ? 'planspopup1100'
          : 'planspopup415',
      ]"
    >
      <div class="lg:p-4">
        <div class="flex justify-between">
          <div>
            <h2 class="font-semibold fsize20">Select Plan</h2>
            <p class="text-gray fsize14 pt-1">
              Please select your preferable subscription plan
            </p>
          </div>

          <feather-icon
            @click="Popupclose"
            icon="XIcon"
            class="cursor-pointer"
          />
        </div>
        <div
          v-if="upgradePlans.length"
          class="lg:grid md:grid flex gap-4 mt-8 role overflow-x-auto"
          :class="[
            upgradePlans.length == 2
              ? 'grid-cols-2'
              : upgradePlans.length == 3
              ? 'grid-cols-3'
              : upgradePlans.length == 4
              ? 'grid-cols-4'
              : 'grid-cols-1',
          ]"
        >
          <div
            class="bg-white shadow-md p-2 rounded-2xl wid-300px h-96 relative"
            v-for="plan in upgradePlans"
            :key="plan._id"
          >
            <div class="wid-280px">
              <div
                class="px-5 py-8 rounded-2xl customroundbrdr"
                :class="[
                  plan.name == 'Business'
                    ? 'bg-primary'
                    : plan.name == 'Essential'
                    ? 'bgprimary-light'
                    : 'col-ed',
                ]"
              >
                <div class="flex gap-4" v-if="plan.name != 'Business'">
                  <img
                    v-if="['Free', 'Starter'].includes(plan.name)"
                    class="w-5 h-5"
                    src="@/assets/images/new-log/dworld.png"
                    alt="white8"
                  />
                  <img
                    v-if="plan.name == 'Essential'"
                    class="w-5 h-5"
                    src="@/assets/images/new-log/white.png"
                    alt="white"
                  />
                </div>
                <div v-if="plan.name == 'Business'" class="flex gap-2">
                  <img
                    class="w-5 h-5 apps-gl object-contain"
                    :src="require('@/assets/images/Ecommerce.png')"
                    alt="white"
                  />
                  <img
                    class="w-5 h-5 object-contain apps-glr"
                    :src="require('@/assets/images/andriod.png')"
                    alt="white2"
                  />
                  <img
                    class="w-5 h-5 object-contain"
                    :src="require('@/assets/images/ios.png')"
                    alt="white3"
                  />
                </div>
                <h1
                  class="fsize20 mt-2 font-semibold"
                  :class="[
                    plan.name == 'Business'
                      ? 'text-white'
                      : plan.name == 'Essential'
                      ? 'text-white'
                      : 'text-393939',
                  ]"
                >
                  {{ plan.name }} <br />subscription
                </h1>
              </div>

              <div class="flex mt-5 justify-center">
                <div class="w-full h270px">
                  <div
                    class="planswitch text-center justify-center 0 mb-4 mt-4"
                  >
                    <h2 class="text-dark font-bold fsize18">
                      {{ plan.sgPrice }}
                      <span class="fsize12"> / Monthly </span>
                    </h2>
                  </div>
                  <div class="y-scroll">
                    <div
                      class="grid grid-cols-1 gap-2 text-left mt-3"
                      v-for="(feature, index) in plan.features"
                      :key="'feature' + index"
                    >
                      <p
                        class="font-semibold fsize12 text-center text-424242"
                        :class="{
                          'text-primary': feature.status,
                          'text-grey': !feature.status,
                        }"
                      >
                        {{ feature.text }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-12 items-end flex btnfix">
              <button
                class="w-full cursor-pointer col-ed border-none rounded-12px fsize14 font-semibold py-4"
                @click="selectPlan(plan)"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";

import { mapState } from "vuex";
export default {
  data() {
    return {
      allSuites: {},
      displaySuites: [],
      search: "",
      selectedItem: "",
      upgradePlans: [],
      upgradePlanPopup: false,
    };
  },
  methods: {
    async selectPlan(plan) {
      const selectedPlanDetails = {
        plan: plan,
        billing: !plan.selected ? plan.plans[0] : plan.plans[1],
      };
      this.$store.commit("scope/SET_PLAN", selectedPlanDetails);
      this.Popupclose();
      this.checkPlan(this.selectedItem);
    },
    Popupclose() {
      this.upgradePlanPopup = false;
    },
    searchCards() {
      if (this.search) {
        const regex = new RegExp(this.search, "i");
        const filter = this.allSuites.filter((item) => regex.test(item.name));
        this.displaySuites = filter;
      } else {
        this.displaySuites = this.allSuites;
      }
    },
    getSuiteImage(img) {
      return img === "Custom.png"
        ? require(`@/assets/images/Custom.png`)
        : `${process.env.VUE_APP_IMAGE_URL}${img}`;
    },
    async getAllSuites() {
      let url = process.env.VUE_APP_BRAINED_API_URL;
      const { data } = await axios.post(url + "brained/suites/view_suites", {
        show: true,
      });
      for (let i = 0; i < data.length; i++) {
        Object.assign(data[i], { selectStatus: false });
      }

      this.allSuites = data;
      this.displaySuites = data;
    },
    setUpgradePlan(item) {
      console.log(item, "suites");
      this.upgradePlans = [];

      this.upgradePlans.push(this.plans[3]);
      this.upgradePlans.push(this.plans[4]);

      for (let index = 0; index < this.upgradePlans.length; index++) {
        if (this.upgradePlans[index].name == "Starter")
          this.upgradePlans[index].sgPrice = "S$19";
        if (this.upgradePlans[index].name == "Prototype")
          this.upgradePlans[index].sgPrice = "S$89";
        if (this.upgradePlans[index].name == "Essential")
          this.upgradePlans[index].sgPrice = "S$399";
        if (this.upgradePlans[index].name == "Business")
          this.upgradePlans[index].sgPrice = "S$1599";
      }
    },
    async checkPlan(item) {
      this.selectedItem = item;
      if (["Free", "Starter"].includes(this.selectedPlan.plan.name)) {
        // 1 suite selectable
        if (this.suites.length <= 1) {
          if (item.type == "Free") {
            if (this.suites.length === 0) {
              item.selectStatus = true;
              this.$store.commit("scope/SET_SUITES", item);
            } else if (
              this.suites.filter((x) => x._id === item._id).length > 0
            ) {
              item.selectStatus = false;
              this.$store.commit("scope/DELETE_SUITES", item);
            } else if (
              !this.suites.filter((x) => x._id === item._id).length > 0
            ) {
              item.selectStatus = true;
              this.$store.commit("scope/REPLACE_SUITES", item);
            }
          } else {
            this.upgradePlanPopup = true;
            this.setUpgradePlan(item);
          }
        }
      } else if (this.selectedPlan.plan.name == "Prototype") {
        // 2 suites selectable
        if (this.suites.length <= 2) {
          if (this.suites.length === 0) {
            console.log("itz");
            this.$store.commit("scope/SET_SUITES", item);
          } else if (this.suites.filter((x) => x._id === item._id).length > 0) {
            item.selectStatus = false;
            this.$store.commit("scope/DELETE_SUITES", item);
          } else if (this.suites.length == 2) {
            item.selectStatus = true;
            this.$store.commit("scope/REPLACE_SUITES", item);
          } else if (
            !this.suites.filter((x) => x._id === item._id).length > 0
          ) {
            item.selectStatus = true;
            this.$store.commit("scope/SET_SUITES", item);
          }
        }
      } else if (this.selectedPlan.plan.name == "Essential") {
        // 2 suites selectable
        if (this.suites.length <= 3) {
          if (this.suites.length === 0) {
            console.log("itz");
            this.$store.commit("scope/SET_SUITES", item);
          } else if (this.suites.filter((x) => x._id === item._id).length > 0) {
            item.selectStatus = false;
            this.$store.commit("scope/DELETE_SUITES", item);
          } else if (this.suites.length == 2) {
            item.selectStatus = true;
            this.$store.commit("scope/REPLACE_SUITES", item);
          } else if (
            !this.suites.filter((x) => x._id === item._id).length > 0
          ) {
            item.selectStatus = true;
            this.$store.commit("scope/SET_SUITES", item);
          }
        }
      } else if (this.selectedPlan.plan.name == "Business") {
        //3 suites selectable
        if (this.suites.length <= 4) {
          if (this.suites.length === 0) {
            console.log("itz");
            this.$store.commit("scope/SET_SUITES", item);
          } else if (this.suites.filter((x) => x._id === item._id).length > 0) {
            item.selectStatus = false;
            this.$store.commit("scope/DELETE_SUITES", item);
          } else if (this.suites.length == 3) {
            item.selectStatus = true;
            this.$store.commit("scope/REPLACE_SUITES", item);
          } else if (
            !this.suites.filter((x) => x._id === item._id).length > 0
          ) {
            item.selectStatus = true;
            this.$store.commit("scope/SET_SUITES", item);
          }
        }
      } else if (this.selectedPlan.plan.name == "Enterprise") {
        // multiple suites selectable
        if (this.suites.length === 0) {
          console.log("itz");
          this.$store.commit("scope/SET_SUITES", item);
        } else if (this.suites.filter((x) => x._id === item._id).length > 0) {
          item.selectStatus = false;
          this.$store.commit("scope/DELETE_SUITES", item);
        } else if (!this.suites.filter((x) => x._id === item._id).length > 0) {
          item.selectStatus = true;
          this.$store.commit("scope/SET_SUITES", item);
        }
      }
      await this.refreshSuites();
      await this.sortData();
    },
    refreshSuites() {
      if (this.suites.length > 0) {
        // this.displaySuites = this.allSuites;

        for (let i = 0; i < this.allSuites.length; i++) {
          this.allSuites[i].selectStatus = false;
        }
        this.displaySuites = this.allSuites;
        console.log(this.allSuites, "all");
        this.suites.forEach((value) => {
          for (let index = 0; index < this.displaySuites.length; index++) {
            if (this.displaySuites[index]._id == value._id) {
              this.displaySuites[index].selectStatus = true;
            }
          }
        });
      }
    },
    sortData() {
      this.displaySuites.sort((x, y) => {
        if (x.type > y.type) {
          return 1;
        } else {
          return -1;
        }
      });
      this.displaySuites.sort(
        (x, y) => Number(y.selectStatus) - Number(x.selectStatus)
      );
      // console.log(this.displayedData);
    },
  },
  async mounted() {
    this.$store.commit("scope/SET_CURRENT_PAGE", "pageSuite");
    await this.getAllSuites();
    await this.refreshSuites();
    await this.sortData();
  },
  computed: {
    ...mapState("scope", ["selectedPlan", "suites", "plans"]),
  },
};
</script>
<style>
.y-scroll {
  overflow-y: auto;
  height: 165px;
}
.y-scroll::-webkit-scrollbar {
  width: 5px;
  background-color: #f1f1f1;
  height: 5px;
}

/* Handle */
.y-scroll::-webkit-scrollbar-thumb {
  background: rgba(var(--vs-primary), 0.5) !important;
  border-radius: 0px 0px 4px 4px;
}
.dialogcustomclass .el-dialog {
  border-radius: 15px !important;
}
.customroundbrdr {
  border-radius: 15px !important;
}
</style>
